import script from "./b-map.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-map.vue?vue&type=script&lang=ts&setup=true"

import "./b-map.vue?vue&type=style&index=0&id=3ccf6b4c&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ccf6b4c"]])

export default __exports__